import React, { Component } from "react"
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { m } from '../../utils';
import './index.css';
import Loading from '../shared/Loading';
import BookingCalendar from './BookingCalendar'
import { Redirect } from 'react-router-dom';

class BookingCalendarQuery extends Component {
  constructor(props) {
    super(props);
    const monthStart = m().clone().startOf('month')
    const monthEnd = monthStart.clone().endOf('month')
    const startDate = monthStart.clone().startOf('isoWeek')
    const endDate = monthEnd.clone().endOf('isoWeek').add(1, 'day')
    this.state = {
      currentMonth: m(),
      shifts: [3, 7, 11, 15, 19, 23],
      tier: this.props.tier,
      startDate: startDate,
      calendarStart: startDate,
      calendarEnd: endDate,
      stretch: Math.ceil(endDate.diff(startDate, "day") / 7) * 7,
      shiftStart: this.props.shiftStart,
      shiftEnd: this.props.shiftEnd,
      flexible: this.props.flexible
    };
  }
  
  render() {
    const { 
      currentMonth, 
      startDate, 
      calendarStart, 
      calendarEnd, 
      stretch
    } = this.state;
    const {
      parkinglotId,
      tier,
      shiftStart,
      shiftEnd,
      formatShift,
      flexible,
      unavailableModal,
      showUnavailableModal,
      newBookingOrientation
    } = this.props;
    return (
      <Query
        query={gql`
        query getAvailability($tier: String!, $startDate: DateTime!, $calendarStart: DateTime!, $calendarEnd: DateTime!, $shiftStart: Int!, $shiftEnd: Int!, $parkinglotId: Int!, $flex: String!) {
            currentUserBookings(startTime: $calendarStart, endTime: $calendarEnd) {
              id
              startTime
              endTime
              vehicleClass
              parkinglot {
                id
                city
                region
              }
              car {
                id
                plate
              }
            }
            shiftAvailability(vehicleClass: $tier, startDate: $startDate, endDate: $calendarEnd, shiftStart: $shiftStart, shiftEnd: $shiftEnd, parkinglotId: $parkinglotId, flex: $flex) {
              startTime
              endTime
              price
              shiftRates
            }
          }
        `}
        variables={{ tier, startDate, calendarStart, calendarEnd, stretch, shiftStart, shiftEnd, parkinglotId, flex: "all" }}
        fetchPolicy="network-only">
        {({ loading, error, data, refetch }) => {
          if (loading) return <div className="load-div"><Loading size="3x" /></div>;
          if (error) return <Redirect to="/404" />;
          let userBookings = {}
          let bookedDates = data.currentUserBookings.map(booking => {
            if (userBookings[new Date(booking.startTime).toDateString()]) {
              userBookings[new Date(booking.startTime).toDateString()].push({startTime: booking.startTime, endTime: booking.endTime})
            } else {
              userBookings[new Date(booking.startTime).toDateString()] = [{startTime: booking.startTime, endTime: booking.endTime}]
            }
            return m(new Date(booking.startTime));
          })
          let prices = {};
          let flexibleDates = {};
          //*extract this logic from bookingcalendar to here maybe improve performance
          data.shiftAvailability.forEach((shift) => {
            let flexibleEnd = shiftStart === m(shift.startTime).hour() ? (shiftEnd === m(shift.endTime).hour() ? false : "finish") : "start";
            if ((!flexibleEnd || flexibleEnd === flexible) &&
              m(shift.startTime).subtract(15, "minute") > m()) {
                let adjustedStart = m(shift.startTime).hour() + (shiftStart > m(shift.startTime).hour() ? 24 : 0);
                let startDiff = adjustedStart - shiftStart;
                let realStart = new Date(m(shift.startTime).subtract(startDiff, "hour")).toDateString()
                prices[realStart] = Object.assign({}, shift,
                                      {
                                        flexible: shiftStart === m(shift.startTime).hour() ? (shiftEnd === m(shift.endTime).hour() ? false : "finish") : "start",
                                      }
                                    );
                flexibleDates[realStart] = Boolean(prices[realStart].flexible);
              }
            //*refactor with dst consideration later
          })
          return (
            <BookingCalendar 
              {...this.props}  
              nextMonth={this.nextMonth}
              prevMonth={this.prevMonth}
              currentMonth={currentMonth}
              bookedDates={bookedDates}
              prices={prices}
              flexibleDates={flexibleDates}
              formatShift={formatShift}
              userBookings={userBookings}
              unavailableModal={unavailableModal}
              showUnavailableModal={showUnavailableModal}
              newBookingOrientation={newBookingOrientation}
              parkinglotId={parkinglotId}
            />
            )
          }}
      </Query>
    )
  }
  
  nextMonth = () => {
    let nextMonth = this.state.currentMonth.add(1, 'month')
    let start = nextMonth.clone().startOf('month').clone().startOf('isoWeek')
    let finish = nextMonth.clone().endOf('month').clone().endOf('isoWeek').add(1, 'day')
    this.setState(
      {
        currentMonth: nextMonth,
        startDate: start,
        calendarStart: start,
        calendarEnd: finish,
        stretch: Math.ceil(finish.diff(start, "day") / 7) * 7
      }
    )
  }

  prevMonth = () => {
    let prevMonth = this.state.currentMonth.subtract(1, 'month')
    let start = prevMonth.clone().startOf('month').clone().startOf('isoWeek')
    let finish = prevMonth.clone().endOf('month').clone().endOf('isoWeek').add(1, 'day')
    this.setState(
      {
        currentMonth: prevMonth,
        startDate: start,
        calendarStart: start,
        calendarEnd: finish,
        stretch: Math.ceil(finish.diff(start, "day") / 7) * 7
      }
    )
  }
}

export default BookingCalendarQuery;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingCalendarQuery.js